import React, { Component } from 'react';
import Helmet from 'react-helmet';
import styled from 'styled-components';

const meta = {
	description: 'A closer look at CSR',
	image: '/images/blog-csr/csr.png',
	title: 'A closer look at CSR | blueshyft',
	url: 'https://blueshyft.com.au/blogs/csr',
};

import '../../css/about.css';

export default class About extends Component {
	render () {

		return (
			<React.Fragment>
				<Helmet
					title={meta.title}
					meta={[
						{ name: 'description', content: meta.description },
						{ property: 'og:title', content: meta.title },
						{ property: 'og:url', content: meta.url },
						{ property: 'og:site_name', content: 'Blueshyft' },
						{ property: 'og:type', content: 'website' },
						{ property: 'og:image', content: meta.image },
						{ property: 'og:description', content: meta.description },
						{ property: 'twitter:card', content: 'summary_large_image' },
						{ property: 'twitter:site', content: '@Blueshyft' },
						{ property: 'twitter:title', content: meta.title },
						{ property: 'twitter:description', content: meta.description },
						{ property: 'twitter:image', content: meta.image },
					]}
				/>

				<section className="about-cryptocurrency">
					<div className="about-cryptocurrency-sub">
						<div className="about-cryptocurrency-image-container">
							<img src="/images/blog-csr/csr.png" alt="csr" className="about-cryptocurrency-image" />
						</div>
					</div>
				</section>

				<section className="wrapup">
					<div className="block block-crypto">
						<p>Corporate Social Responsibility is a concept  often associated with ethical-oriented practices conducted by businesses. We would like to highlight the range of initiatives that our partners and blueshyft are conducting, from environmental programs to corporate governance.</p>
					</div>

					<div className="block block-crypto">
						<h4>Ladbrokes</h4>
						<p>The Entain Group (parent company of Ladbrokes) pays particularly close attention to the environmental aspect of its operations. In 2021 alone, the group achieved the BSI ISO14001 Environmental Management System accreditation, the world’s most recognisable environmental accreditation . Further, The Entain Group received independent verification of GHG emissions data from the Carbon Trust earlier this year. This third party specialises in greenhouse gas emissions reduction and resource efficiency. Finally, they formulated specific goals to remain environmentally sustainable; for example, net zero emissions by 2035.</p>
					</div>

					<div className="block block-crypto">
						<h4>Coinspot</h4>
						<p>Another partner, Coinspot, has acquired the ISO 27001 accreditation for information security. With the earlier bull run this year, many users turned their attention to large exchanges and their integrated security systems. With this accreditation, customers can feel a sense of security when they are transacting and depositing large sums of money. Raising the bar, and conducting an external audit (which is what the ISO 27001 entails) depicts a sense of corporate responsibility, which is a significant benefit for large corporations.</p>
					</div>

					<div className="block block-crypto">
						<h4>TNT/FedEx</h4>
						<p>TNT/FedEx continues their CSR efforts through various initiatives. With its global recognition, TNT/FedEx aims to have a holistic approach to reducing carbon emissions through its Environment Management System. This system focuses on capital expenditure and procurement review processes. Coupled with this overarching goal of improving operational efficiencies, they are also accredited with numerous ISO standards.</p>
					</div>

					<div className="block block-crypto">
						<h4>blueshyft</h4>
						<p>At blueshyft, we have implemented a number of CSR initiatives. Earlier this year, we donated over 30 iPads to WAYS - a youth support charity that is dedicated to creating meaningful pathways for young people. Through our donation, WAYS has increased access to resources through fully functioning iPads that benefit the learning of students. Furthermore, providing a service that works in conjunction with digital businesses to bring communities together is at the forefront of our mission. Not only are we helping our partners to expand their product offerings, but also supporting local businesses by adding value and revenue streams at no cost. In future, we will build upon these initiatives by reducing our environmental impact. When sending out hardware, we aim to recycle 100% of the packaging used as well as re-purposing older iPads.</p>
						<p>Thanks for your continued support of the environment, CSR and blueshyft.</p>
					</div>
				</section>

			</React.Fragment>
		);
	}
};



// WEBPACK FOOTER //
// ./client/scenes/blog-20210727/index.js